import o, { useState as I, useCallback as ae, useRef as Z, useMemo as J, useEffect as X } from "react";
import { useFormContext as _e } from "react-hook-form";
import { Command as Ae, CommandInput as Fe, CommandList as $e, CommandEmpty as Oe, CommandGroup as je, CommandItem as Ie } from "@appchoose/command";
import Re from "@appchoose/flag";
import { FormField as q, FormItem as _, FormLabel as A, FormControl as F, FormMessage as C } from "@appchoose/form";
import ce from "@appchoose/icon";
import { Popover as Me, PopoverTrigger as De, PopoverContent as Te } from "@appchoose/popover";
import Ge, { SelectTrigger as Ze, SelectValue as Ke, SelectContent as He, SelectItem as Be } from "@appchoose/select";
import { APIProvider as Ue, useApiLoadingStatus as We, APILoadingStatus as oe } from "@vis.gl/react-google-maps";
import { matchSorter as Je } from "match-sorter";
import { Combobox as Qe, InputContainer as Xe, ComboboxInput as Ye, ComboboxPopover as et, ComboboxList as tt, ComboboxSection as rt, ComboboxHeader as ot, ComboboxItem as nt, HighlightText as lt } from "@appchoose/combobox";
let y;
(function(e) {
  e.FirstName = "firstName", e.LastName = "lastName", e.Country = "country", e.City = "city", e.PostalCode = "zip", e.Zone = "province", e.Address1 = "address1", e.Address2 = "address2", e.Phone = "phone", e.Company = "company";
})(y || (y = {}));
const ye = "https://atlas.shopifysvc.com/graphql";
let de;
(function(e) {
  e.Countries = "countries", e.Country = "country";
})(de || (de = {}));
const ve = {
  "Content-Type": "application/json",
  "Access-Control-Allow-Origin": "*"
}, at = `
query countries($locale: SupportedLocale!) {
  countries(locale: $locale) {
    name
    code
    continent
    phoneNumberPrefix
    autocompletionField
    provinceKey
    labels {
      address1
      address2
      city
      company
      country
      firstName
      lastName
      phone
      postalCode
      zone
    }
    optionalLabels {
      address2
    }
    formatting {
      edit
      show
    }
    zones {
      name
      code
    }
  }
}

query country($countryCode: SupportedCountry!, $locale: SupportedLocale!) {
  country(countryCode: $countryCode, locale: $locale) {
    name
    code
    continent
    phoneNumberPrefix
    autocompletionField
    provinceKey
    labels {
      address1
      address2
      city
      company
      country
      firstName
      lastName
      phone
      postalCode
      zone
    }
    optionalLabels {
      address2
    }
    formatting {
      edit
      show
    }
    zones {
      name
      code
    }
  }
}
`;
var xe = at;
const st = we(async (e, {
  includeHiddenZones: t = !1
} = {}) => {
  const r = await (await fetch(ye, {
    method: "POST",
    headers: ve,
    body: JSON.stringify({
      query: xe,
      operationName: de.Countries,
      variables: {
        locale: e.replace(/-/, "_").toUpperCase(),
        includeHiddenZones: t
      }
    })
  })).json();
  if (!("data" in r) && "errors" in r)
    throw new Ee(r);
  return r.data.countries;
}), it = we(async (e, t, {
  includeHiddenZones: r = !1
} = {}) => {
  const n = await (await fetch(ye, {
    method: "POST",
    headers: ve,
    body: JSON.stringify({
      query: xe,
      operationName: de.Country,
      variables: {
        countryCode: t,
        locale: e.replace(/-/, "_").toUpperCase(),
        includeHiddenZones: r
      }
    })
  })).json();
  if (!("data" in n) && "errors" in n)
    throw new Ee(n);
  return n.data.country;
});
class Ee extends Error {
  constructor(t) {
    const r = t.errors.map((n) => n.message).join("; ");
    super(r);
  }
}
function we(e) {
  const t = {};
  return (...r) => {
    const n = JSON.stringify(r);
    return t[n] || (t[n] = e.apply(this, r)), t[n];
  };
}
const Ce = /({\w+})/g, ct = {
  "{firstName}": y.FirstName,
  "{lastName}": y.LastName,
  "{country}": y.Country,
  "{city}": y.City,
  "{zip}": y.PostalCode,
  "{province}": y.Zone,
  "{address1}": y.Address1,
  "{address2}": y.Address2,
  "{phone}": y.Phone,
  "{company}": y.Company
};
function dt(e, t, r) {
  const n = t.match(Ce);
  let a = t;
  if (!n)
    return "";
  let s = !0;
  return n.forEach((c) => {
    const l = c.replace("{", "").replace("}", "");
    switch (r[l] && (s = !1), l) {
      case y.Country:
        a = a.replace(`{${y.Country}}`, e.name);
        break;
      case y.Zone:
        a = a.replace(`{${y.Zone}}`, r.province ? ut(e.zones, r.province).name : "");
        break;
      default:
        a = a.replace(c, r[l] || "");
        break;
    }
  }), s ? "" : a.trim().replace("  ", " ");
}
function ut(e, t) {
  return e.find((r) => r.code === t) || {
    name: "",
    code: ""
  };
}
const ke = "_", mt = "{firstName}{lastName}_{company}_{address1}_{address2}_{city}_{country}{province}{zip}_{phone}", pt = "{lastName} {firstName}_{company}_{address1} {address2}_{city} {province} {zip}_{country}_{phone}";
function ft(e, t) {
  return (t.formatting.show || pt).split(ke).map((r) => dt(t, r, e).trim());
}
function gt(e) {
  return (e ? e.formatting.edit : mt).split(ke).map((t) => {
    const r = t.match(Ce);
    return r ? r.map((n) => ct[n]) : [];
  });
}
const ie = /* @__PURE__ */ new Map();
class Le {
  /**
   * Useful in tests or any situation where the cache has undesirable
   * side-effects.
   */
  static resetCache() {
    ie.clear();
  }
  constructor(t) {
    this.locale = t, this.locale = t;
  }
  updateLocale(t) {
    this.locale = t;
  }
  async getCountry(t, {
    includeHiddenZones: r = !1
  } = {}) {
    return this.loadCountryFromCache(t, r) || it(this.locale, t, {
      includeHiddenZones: r
    });
  }
  async getCountries({
    includeHiddenZones: t = !1
  } = {}) {
    const r = this.cacheKey(this.locale, t), n = ie.get(r);
    if (n) return n;
    const a = await st(this.locale, {
      includeHiddenZones: t
    });
    return ie.set(r, a), a;
  }
  async getZoneName(t, r) {
    const n = (await this.getCountry(t)).zones.find((a) => a.code === r);
    if (n != null && n.name)
      return n.name;
  }
  /* Returns the address ordered in an array based based on the country code
   * Eg.:
   *   [
   *     'Shopify',
   *     'First Name Last Name',
   *     'Address 1',
   *     'address2',
   *     'Montréal',
   *     'Canada Quebec H2J 4B7',
   *     '514 444 3333'
   *   ]
   */
  async format(t) {
    const r = await this.getCountry(t.country);
    return ft(t, r);
  }
  /* Returns an array that shows how to order fields based on the country code
   * Eg.:
   *   [
   *     ['company'],
   *     ['firstName', 'lastName'],
   *     ['address1'],
   *     ['address2'],
   *     ['city'],
   *     ['country', 'province', 'zip'],
   *     ['phone']
   *   ]
   */
  async getOrderedFields(t) {
    const r = await this.getCountry(t);
    return gt(r);
  }
  cacheKey(t, r) {
    return `${t}-${r}`;
  }
  loadCountryFromCache(t, r) {
    const n = ie.get(this.cacheKey(this.locale, r));
    return n ? n.find(({
      code: a
    }) => a === t) : null;
  }
}
const bt = async (e, t) => {
  let r = await new Le("FR").getOrderedFields(e);
  return [...t, y.Country].forEach((n) => {
    r.forEach((a) => {
      const s = a.findIndex(
        (c) => c.includes(n)
      );
      s !== -1 && a.splice(s, 1);
    });
  }), r = r.filter(
    (n) => n.length > 0
  ), r.unshift([y.Country]), r;
}, ht = (e) => [
  [y.Country],
  [y.Company],
  [y.FirstName, y.LastName],
  [y.Address1],
  [y.Address2],
  [y.PostalCode, y.City],
  [y.Phone]
].map(
  (t) => t.filter((r) => !e.includes(r))
).filter((t) => t.length > 0), yt = (e) => new Le(e).getCountries();
function Pe(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var a = e.length;
    for (t = 0; t < a; t++) e[t] && (r = Pe(e[t])) && (n && (n += " "), n += r);
  } else for (r in e) e[r] && (n && (n += " "), n += r);
  return n;
}
function vt() {
  for (var e, t, r = 0, n = "", a = arguments.length; r < a; r++) (e = arguments[r]) && (t = Pe(e)) && (n && (n += " "), n += t);
  return n;
}
const fe = "-", xt = (e) => {
  const t = wt(e), {
    conflictingClassGroups: r,
    conflictingClassGroupModifiers: n
  } = e;
  return {
    getClassGroupId: (a) => {
      const s = a.split(fe);
      return s[0] === "" && s.length !== 1 && s.shift(), Ne(s, t) || Et(a);
    },
    getConflictingClassGroupIds: (a, s) => {
      const c = r[a] || [];
      return s && n[a] ? [...c, ...n[a]] : c;
    }
  };
}, Ne = (e, t) => {
  if (e.length === 0)
    return t.classGroupId;
  const r = e[0], n = t.nextPart.get(r), a = n ? Ne(e.slice(1), n) : void 0;
  if (a)
    return a;
  if (t.validators.length === 0)
    return;
  const s = e.join(fe);
  return t.validators.find(({
    validator: c
  }) => c(s))?.classGroupId;
}, ge = /^\[(.+)\]$/, Et = (e) => {
  if (ge.test(e)) {
    const t = ge.exec(e)[1], r = t?.substring(0, t.indexOf(":"));
    if (r)
      return "arbitrary.." + r;
  }
}, wt = (e) => {
  const {
    theme: t,
    prefix: r
  } = e, n = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return kt(Object.entries(e.classGroups), r).forEach(([a, s]) => {
    me(s, n, a, t);
  }), n;
}, me = (e, t, r, n) => {
  e.forEach((a) => {
    if (typeof a == "string") {
      const s = a === "" ? t : be(t, a);
      s.classGroupId = r;
      return;
    }
    if (typeof a == "function") {
      if (Ct(a)) {
        me(a(n), t, r, n);
        return;
      }
      t.validators.push({
        validator: a,
        classGroupId: r
      });
      return;
    }
    Object.entries(a).forEach(([s, c]) => {
      me(c, be(t, s), r, n);
    });
  });
}, be = (e, t) => {
  let r = e;
  return t.split(fe).forEach((n) => {
    r.nextPart.has(n) || r.nextPart.set(n, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), r = r.nextPart.get(n);
  }), r;
}, Ct = (e) => e.isThemeGetter, kt = (e, t) => t ? e.map(([r, n]) => {
  const a = n.map((s) => typeof s == "string" ? t + s : typeof s == "object" ? Object.fromEntries(Object.entries(s).map(([c, l]) => [t + c, l])) : s);
  return [r, a];
}) : e, Lt = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, r = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  const a = (s, c) => {
    r.set(s, c), t++, t > e && (t = 0, n = r, r = /* @__PURE__ */ new Map());
  };
  return {
    get(s) {
      let c = r.get(s);
      if (c !== void 0)
        return c;
      if ((c = n.get(s)) !== void 0)
        return a(s, c), c;
    },
    set(s, c) {
      r.has(s) ? r.set(s, c) : a(s, c);
    }
  };
}, Se = "!", Pt = (e) => {
  const {
    separator: t,
    experimentalParseClassName: r
  } = e, n = t.length === 1, a = t[0], s = t.length, c = (l) => {
    const d = [];
    let u = 0, f = 0, g;
    for (let E = 0; E < l.length; E++) {
      let k = l[E];
      if (u === 0) {
        if (k === a && (n || l.slice(E, E + s) === t)) {
          d.push(l.slice(f, E)), f = E + s;
          continue;
        }
        if (k === "/") {
          g = E;
          continue;
        }
      }
      k === "[" ? u++ : k === "]" && u--;
    }
    const S = d.length === 0 ? l : l.substring(f), p = S.startsWith(Se), N = p ? S.substring(1) : S, x = g && g > f ? g - f : void 0;
    return {
      modifiers: d,
      hasImportantModifier: p,
      baseClassName: N,
      maybePostfixModifierPosition: x
    };
  };
  return r ? (l) => r({
    className: l,
    parseClassName: c
  }) : c;
}, Nt = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let r = [];
  return e.forEach((n) => {
    n[0] === "[" ? (t.push(...r.sort(), n), r = []) : r.push(n);
  }), t.push(...r.sort()), t;
}, St = (e) => ({
  cache: Lt(e.cacheSize),
  parseClassName: Pt(e),
  ...xt(e)
}), zt = /\s+/, Vt = (e, t) => {
  const {
    parseClassName: r,
    getClassGroupId: n,
    getConflictingClassGroupIds: a
  } = t, s = [], c = e.trim().split(zt);
  let l = "";
  for (let d = c.length - 1; d >= 0; d -= 1) {
    const u = c[d], {
      modifiers: f,
      hasImportantModifier: g,
      baseClassName: S,
      maybePostfixModifierPosition: p
    } = r(u);
    let N = !!p, x = n(N ? S.substring(0, p) : S);
    if (!x) {
      if (!N) {
        l = u + (l.length > 0 ? " " + l : l);
        continue;
      }
      if (x = n(S), !x) {
        l = u + (l.length > 0 ? " " + l : l);
        continue;
      }
      N = !1;
    }
    const E = Nt(f).join(":"), k = g ? E + Se : E, L = k + x;
    if (s.includes(L))
      continue;
    s.push(L);
    const h = a(x, N);
    for (let V = 0; V < h.length; ++V) {
      const M = h[V];
      s.push(k + M);
    }
    l = u + (l.length > 0 ? " " + l : l);
  }
  return l;
};
function qt() {
  let e = 0, t, r, n = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (r = ze(t)) && (n && (n += " "), n += r);
  return n;
}
const ze = (e) => {
  if (typeof e == "string")
    return e;
  let t, r = "";
  for (let n = 0; n < e.length; n++)
    e[n] && (t = ze(e[n])) && (r && (r += " "), r += t);
  return r;
};
function _t(e, ...t) {
  let r, n, a, s = c;
  function c(d) {
    const u = t.reduce((f, g) => g(f), e());
    return r = St(u), n = r.cache.get, a = r.cache.set, s = l, l(d);
  }
  function l(d) {
    const u = n(d);
    if (u)
      return u;
    const f = Vt(d, r);
    return a(d, f), f;
  }
  return function() {
    return s(qt.apply(null, arguments));
  };
}
const w = (e) => {
  const t = (r) => r[e] || [];
  return t.isThemeGetter = !0, t;
}, Ve = /^\[(?:([a-z-]+):)?(.+)\]$/i, At = /^\d+\/\d+$/, Ft = /* @__PURE__ */ new Set(["px", "full", "screen"]), $t = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Ot = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, jt = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, It = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, Rt = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, R = (e) => Q(e) || Ft.has(e) || At.test(e), T = (e) => Y(e, "length", Bt), Q = (e) => !!e && !Number.isNaN(Number(e)), ue = (e) => Y(e, "number", Q), ne = (e) => !!e && Number.isInteger(Number(e)), Mt = (e) => e.endsWith("%") && Q(e.slice(0, -1)), m = (e) => Ve.test(e), G = (e) => $t.test(e), Dt = /* @__PURE__ */ new Set(["length", "size", "percentage"]), Tt = (e) => Y(e, Dt, qe), Gt = (e) => Y(e, "position", qe), Zt = /* @__PURE__ */ new Set(["image", "url"]), Kt = (e) => Y(e, Zt, Wt), Ht = (e) => Y(e, "", Ut), le = () => !0, Y = (e, t, r) => {
  const n = Ve.exec(e);
  return n ? n[1] ? typeof t == "string" ? n[1] === t : t.has(n[1]) : r(n[2]) : !1;
}, Bt = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  Ot.test(e) && !jt.test(e)
), qe = () => !1, Ut = (e) => It.test(e), Wt = (e) => Rt.test(e), Jt = () => {
  const e = w("colors"), t = w("spacing"), r = w("blur"), n = w("brightness"), a = w("borderColor"), s = w("borderRadius"), c = w("borderSpacing"), l = w("borderWidth"), d = w("contrast"), u = w("grayscale"), f = w("hueRotate"), g = w("invert"), S = w("gap"), p = w("gradientColorStops"), N = w("gradientColorStopPositions"), x = w("inset"), E = w("margin"), k = w("opacity"), L = w("padding"), h = w("saturate"), V = w("scale"), M = w("sepia"), se = w("skew"), ee = w("space"), H = w("translate"), D = () => ["auto", "contain", "none"], te = () => ["auto", "hidden", "clip", "visible", "scroll"], B = () => ["auto", m, t], b = () => [m, t], U = () => ["", R, T], K = () => ["auto", Q, m], W = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], i = () => ["solid", "dashed", "dotted", "double", "none"], z = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], v = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], O = () => ["", "0", m], re = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], $ = () => [Q, m];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [le],
      spacing: [R, T],
      blur: ["none", "", G, m],
      brightness: $(),
      borderColor: [e],
      borderRadius: ["none", "", "full", G, m],
      borderSpacing: b(),
      borderWidth: U(),
      contrast: $(),
      grayscale: O(),
      hueRotate: $(),
      invert: O(),
      gap: b(),
      gradientColorStops: [e],
      gradientColorStopPositions: [Mt, T],
      inset: B(),
      margin: B(),
      opacity: $(),
      padding: b(),
      saturate: $(),
      scale: $(),
      sepia: O(),
      skew: $(),
      space: b(),
      translate: b()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", m]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [G]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": re()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": re()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...W(), m]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: te()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": te()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": te()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: D()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": D()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": D()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [x]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [x]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [x]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [x]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [x]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [x]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [x]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [x]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [x]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", ne, m]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: B()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", m]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: O()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: O()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", ne, m]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [le]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", ne, m]
        }, m]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": K()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": K()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [le]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [ne, m]
        }, m]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": K()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": K()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", m]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", m]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [S]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [S]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [S]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...v()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...v(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...v(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [L]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [L]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [L]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [L]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [L]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [L]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [L]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [L]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [L]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [E]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [E]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [E]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [E]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [E]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [E]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [E]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [E]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [E]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [ee]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [ee]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", m, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [m, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [m, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [G]
        }, G]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [m, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [m, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [m, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [m, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", G, T]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", ue]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [le]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", m]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Q, ue]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", R, m]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", m]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", m]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [k]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [k]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...i(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", R, T]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", R, m]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: b()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", m]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", m]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [k]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...W(), Gt]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", Tt]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, Kt]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [N]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [N]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [N]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [p]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [p]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [p]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [s]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [s]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [s]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [s]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [s]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [s]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [s]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [s]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [s]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [s]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [s]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [s]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [s]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [s]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [s]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [l]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [l]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [l]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [l]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [l]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [l]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [l]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [l]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [l]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [k]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...i(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [l]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [l]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [k]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: i()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [a]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [a]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [a]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [a]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [a]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [a]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [a]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [a]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [a]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [a]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...i()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [R, m]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [R, T]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: U()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [k]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [R, T]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", G, Ht]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [le]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [k]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...z(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": z()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [r]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [n]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [d]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", G, m]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [u]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [f]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [g]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [h]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [M]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [r]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [n]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [d]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [u]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [f]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [g]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [k]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [h]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [M]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [c]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [c]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [c]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", m]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: $()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", m]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: $()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", m]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [V]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [V]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [V]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [ne, m]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [H]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [H]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [se]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [se]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", m]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", m]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": b()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": b()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": b()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": b()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": b()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": b()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": b()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": b()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": b()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": b()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": b()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": b()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": b()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": b()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": b()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": b()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": b()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": b()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", m]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [R, T, ue]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, Qt = /* @__PURE__ */ _t(Jt);
function pe(...e) {
  return Qt(vt(e));
}
const j = o.forwardRef(
  ({ className: e, type: t, startAdornment: r, endAdornment: n, ...a }, s) => /* @__PURE__ */ o.createElement("div", { className: "relative w-full text-gray-500 transition-colors duration-300 focus-within:text-gray-900" }, r ?? null, /* @__PURE__ */ o.createElement(
    "input",
    {
      type: t,
      className: pe(
        'form-input block w-full rounded border border-gray-500 p-2 text-sm leading-5.5 text-gray-900 placeholder-gray-500 outline-none transition duration-300 hover:border-gray-700 focus:border-gray-700 focus:ring-gray-700 disabled:cursor-not-allowed disabled:border-gray-100 disabled:bg-gray-50 disabled:text-gray-500 disabled:placeholder-gray-300 aria-[invalid="true"]:border-red-600 aria-[invalid="true"]:ring-red-600',
        {
          "pl-8": !!r,
          "peer pr-8": !!n
        },
        e
      ),
      ref: s,
      ...a
    }
  ), n ?? null)
);
j.displayName = "Input";
let P;
(function(e) {
  e.FirstName = "firstName", e.LastName = "lastName", e.Country = "country", e.City = "city", e.PostalCode = "zip", e.Zone = "province", e.Address1 = "address1", e.Address2 = "address2", e.Phone = "phone", e.Company = "company";
})(P || (P = {}));
let he;
(function(e) {
  e.Countries = "countries", e.Country = "country";
})(he || (he = {}));
function Xt(e) {
  const t = Z(e);
  return t.current = e, J(() => Object.freeze({
    get current() {
      return t.current;
    }
  }), []);
}
function Yt(e) {
  const t = Xt(e);
  X(
    () => () => {
      t.current();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
}
function er(e, t, r, n = 0) {
  const a = Z(void 0), s = Z(void 0), c = Z(e), l = Z(void 0), d = () => {
    a.current && (clearTimeout(a.current), a.current = void 0), s.current && (clearTimeout(s.current), s.current = void 0);
  };
  return Yt(d), X(() => {
    c.current = e;
  }, t), J(() => {
    const u = () => {
      if (d(), !l.current)
        return;
      const g = l.current;
      l.current = void 0, c.current.apply(g.this, g.args);
    }, f = function(...g) {
      a.current && clearTimeout(a.current), l.current = { args: g, this: this }, a.current = setTimeout(u, r), n > 0 && !s.current && (s.current = setTimeout(u, n));
    };
    return Object.defineProperties(f, {
      length: { value: e.length },
      name: { value: `${e.name || "anonymous"}__debounced__${r}` }
    }), f;
  }, [r, n, ...t]);
}
const tr = ({
  defaultValue: e = "",
  requestOptions: t
}) => {
  const [r] = I(new google.maps.places.AutocompleteService()), [n, a] = I(e), [s, c] = I({
    loading: !1,
    status: "",
    data: []
  }), l = er(
    (u) => {
      c((f) => ({ ...f, loading: !0 })), r.getPlacePredictions(
        {
          ...t,
          input: u
        },
        (f, g) => {
          c({
            loading: !1,
            status: g,
            data: f ?? []
          });
        }
      );
    },
    [r, t],
    150
  ), d = ae(
    (u) => {
      a(u), l(u);
    },
    [l]
  );
  return {
    value: n,
    setValue: d,
    loading: s.loading,
    status: s.status,
    data: s.data
  };
}, rr = ({
  defaultValue: e = "",
  requestOptions: t
}) => {
  const [r] = I(
    new google.maps.places.PlacesService(document.createElement("div"))
  ), [n, a] = I(e), [s, c] = I({
    loading: !1,
    status: "",
    data: null
  }), l = ae(
    (u) => {
      c((f) => ({ ...f, loading: !0 })), r.getDetails(
        {
          ...t,
          placeId: u
        },
        (f, g) => {
          c({
            loading: !1,
            status: g,
            data: f
          });
        }
      );
    },
    [r, t]
  ), d = ae(
    (u) => {
      a(u), l(u);
    },
    [l]
  );
  return {
    value: n,
    setValue: d,
    loading: s.loading,
    status: s.status,
    data: s.data
  };
}, or = () => {
};
function nr() {
  const e = Z(!0);
  return X(() => {
    e.current = !1;
  }, []), e.current;
}
function lr(e, t) {
  const r = nr();
  X(r ? or : e, t);
}
const ar = (e) => {
  const t = e.address_components?.find(
    (d) => !!d.types.includes("street_number")
  )?.long_name, r = e.address_components?.find(
    (d) => !!d.types.includes("route")
  )?.long_name, n = e.address_components?.find(
    (d) => !!d.types.includes("locality")
  )?.long_name ?? e.address_components?.find(
    (d) => !!d.types.includes("postal_town")
  )?.long_name, a = e.address_components?.find(
    (d) => !!d.types.includes("administrative_area_level_1")
  )?.short_name, s = e.address_components?.find(
    (d) => !!d.types.includes("country")
  )?.long_name, c = e.address_components?.find(
    (d) => !!d.types.includes("country")
  )?.short_name, l = e.address_components?.find(
    (d) => !!d.types.includes("postal_code")
  )?.long_name;
  return {
    street: [t, r].filter(Boolean).join(" "),
    city: n ?? "",
    province: a ?? "",
    country: s ?? "",
    countryCode: c ?? "",
    bp: l ?? ""
  };
}, sr = ({
  id: e,
  defaultValue: t,
  onSelectionChange: r,
  onInputChange: n,
  invalid: a,
  countryRestrictions: s,
  translations: c,
  className: l
}) => {
  const [d, u] = I({
    selectedKey: "",
    inputValue: t ?? ""
  }), { setValue: f, data: g } = tr({
    requestOptions: {
      types: ["address"],
      componentRestrictions: { country: s }
    }
  }), { setValue: S, data: p } = rr({
    requestOptions: { fields: ["address_components"] }
  }), N = g.map((h) => ({
    label: h.description,
    value: h.place_id
  })), x = J(
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    () => p ? ar(p) : null,
    [p]
  );
  lr(() => {
    x && r(x);
  }, [x]);
  const E = (h) => {
    h !== null && (u({
      inputValue: N.find((V) => V.value === h)?.label ?? "",
      selectedKey: h
    }), S(h));
  }, k = (h) => {
    u(
      (V) => ({
        inputValue: h,
        selectedKey: h === "" ? null : V.selectedKey
      })
    ), f(h), n?.(h);
  }, L = () => {
    u({
      selectedKey: "",
      inputValue: ""
    });
  };
  return /* @__PURE__ */ o.createElement(
    Qe,
    {
      selectedKey: d.selectedKey,
      inputValue: d.inputValue,
      onSelectionChange: E,
      onInputChange: k,
      items: N,
      allowsCustomValue: !0,
      allowsEmptyCollection: !1,
      className: l
    },
    /* @__PURE__ */ o.createElement(Xe, null, /* @__PURE__ */ o.createElement("div", { className: "absolute inset-y-0 left-0 flex items-center pl-2" }, /* @__PURE__ */ o.createElement(ce, { icon: "search" })), /* @__PURE__ */ o.createElement(
      Ye,
      {
        id: e,
        className: "pl-8",
        name: "street",
        "aria-invalid": a,
        placeholder: c.fieldsStreetPlaceholder
      }
    ), d.selectedKey ? /* @__PURE__ */ o.createElement("div", { className: "absolute inset-y-0 right-0 flex items-center pr-2" }, /* @__PURE__ */ o.createElement(
      "button",
      {
        onClick: L,
        type: "button",
        className: "text-sm font-semibold"
      },
      /* @__PURE__ */ o.createElement(ce, { icon: "close" })
    )) : null),
    /* @__PURE__ */ o.createElement(et, null, /* @__PURE__ */ o.createElement(tt, null, N.length ? /* @__PURE__ */ o.createElement(rt, null, /* @__PURE__ */ o.createElement(ot, null, c.suggestions), N.map((h) => /* @__PURE__ */ o.createElement(
      nt,
      {
        id: h.value,
        key: h.value,
        textValue: h.label
      },
      /* @__PURE__ */ o.createElement(
        lt,
        {
          textToHighlight: d.inputValue,
          value: h.label,
          className: "data-[user-value=true]:font-semibold"
        }
      )
    ))) : null))
  );
}, ir = ({
  countryCode: e = "",
  fieldsToRemove: t = []
}) => {
  const [r, n] = I({
    loading: !1
  }), a = ae(async () => {
    n({ loading: !0 });
    try {
      const s = await bt(
        e,
        t
      );
      n({
        loading: !1,
        data: s,
        error: void 0
      });
    } catch (s) {
      n({
        loading: !1,
        error: s,
        data: void 0
      });
    }
  }, [e, t]);
  return X(() => {
    a();
  }, [a]), { ...r };
}, cr = ({ locale: e = "" }) => {
  const [t, r] = I({
    loading: !1
  }), n = ae(async () => {
    r({ loading: !0 });
    try {
      const a = await yt(e);
      r({
        loading: !1,
        data: a,
        error: void 0
      });
    } catch (a) {
      r({
        loading: !1,
        error: a,
        data: void 0
      });
    }
  }, [e]);
  return X(() => {
    n();
  }, [n]), { ...t };
}, wr = ({
  showCompany: e,
  showName: t,
  showPhone: r,
  autoFocus: n,
  disabledCountry: a,
  countryRestrictions: s,
  googleMapsApiKey: c,
  locale: l,
  translations: d,
  formPrefix: u
}) => /* @__PURE__ */ o.createElement(Ue, { apiKey: c, libraries: ["places"] }, /* @__PURE__ */ o.createElement(
  dr,
  {
    showCompany: e,
    showName: t,
    showPhone: r,
    autoFocus: n,
    disabledCountry: a,
    countryRestrictions: s,
    googleMapsApiKey: c,
    locale: l,
    translations: d,
    formPrefix: u
  }
)), dr = ({
  showCompany: e,
  showName: t,
  showPhone: r,
  autoFocus: n,
  disabledCountry: a,
  countryRestrictions: s,
  locale: c,
  translations: l,
  formPrefix: d
}) => {
  const { control: u, getValues: f, setValue: g, watch: S } = _e(), p = (i) => d ? `${d}.${i}` : i, N = J(() => {
    const i = [];
    return r || i.push(P.Phone), e || i.push(P.Company), t || (i.push(P.FirstName), i.push(P.LastName)), i;
  }, [e, t, r]), x = f(p("countryCode"))?.toUpperCase() ?? "FR", {
    data: E,
    loading: k
  } = ir({
    countryCode: x,
    fieldsToRemove: N
  }), L = E ?? ht(N), { data: h, loading: V } = cr({
    locale: c.toUpperCase()
  }), [M, se] = o.useState(""), ee = Z(null), H = Z(), D = J(
    () => h?.map((i) => ({
      value: i.code,
      label: i.name,
      leftSection: /* @__PURE__ */ o.createElement("div", { className: "mr-2 flex h-4 items-center" }, /* @__PURE__ */ o.createElement(Re, { flag: i.code }))
    })) ?? [],
    [h]
  ), te = J(
    () => Je(D, M, { keys: ["label"] }),
    [D, M]
  ), B = h?.find(
    (i) => i.code === x
  ), b = We(), [U, K] = I(!1);
  S(p("countryCode")), S(p("province"));
  const W = {
    [P.Company]: e ? /* @__PURE__ */ o.createElement(
      q,
      {
        control: u,
        name: p("name"),
        rules: { required: !0, maxLength: 200 },
        render: ({ field: i }) => /* @__PURE__ */ o.createElement(_, null, /* @__PURE__ */ o.createElement(A, null, l.fieldsNameLabel), /* @__PURE__ */ o.createElement(F, null, /* @__PURE__ */ o.createElement(
          j,
          {
            type: "text",
            placeholder: l.fieldsNamePlaceholder,
            autoFocus: n,
            ...i
          }
        )), /* @__PURE__ */ o.createElement(C, { match: "required" }, l.fieldsNameValidationErrorsRequired), /* @__PURE__ */ o.createElement(C, { match: "maxLength" }, l.fieldsNameValidationErrorsMaxLength))
      }
    ) : null,
    [P.FirstName]: t ? /* @__PURE__ */ o.createElement(
      q,
      {
        control: u,
        name: p("firstname"),
        rules: { required: !0, maxLength: 200 },
        render: ({ field: i }) => /* @__PURE__ */ o.createElement(_, null, /* @__PURE__ */ o.createElement(A, null, l.fieldsFirstnameLabel), /* @__PURE__ */ o.createElement(F, null, /* @__PURE__ */ o.createElement(
          j,
          {
            type: "text",
            placeholder: l.fieldsFirstnamePlaceholder,
            ...i
          }
        )), /* @__PURE__ */ o.createElement(C, { match: "required" }, l.fieldsFirstnameValidationErrorsRequired), /* @__PURE__ */ o.createElement(C, { match: "maxLength" }, l.fieldsFirstnameValidationErrorsMaxLength))
      }
    ) : null,
    [P.LastName]: t ? /* @__PURE__ */ o.createElement(
      q,
      {
        control: u,
        name: p("lastname"),
        rules: { required: !0, maxLength: 200 },
        render: ({ field: i }) => /* @__PURE__ */ o.createElement(_, null, /* @__PURE__ */ o.createElement(A, null, l.fieldsLastnameLabel), /* @__PURE__ */ o.createElement(F, null, /* @__PURE__ */ o.createElement(
          j,
          {
            type: "text",
            placeholder: l.fieldsLastnamePlaceholder,
            ...i
          }
        )), /* @__PURE__ */ o.createElement(C, { match: "required" }, l.fieldsLastnameValidationErrorsRequired), /* @__PURE__ */ o.createElement(C, { match: "maxLength" }, l.fieldsLastnameValidationErrorsMaxLength))
      }
    ) : null,
    [P.Phone]: r ? /* @__PURE__ */ o.createElement(
      q,
      {
        control: u,
        name: p("phone"),
        rules: { required: !0, maxLength: 200 },
        render: ({ field: i }) => /* @__PURE__ */ o.createElement(_, null, /* @__PURE__ */ o.createElement(A, null, l.fieldsPhoneLabel), /* @__PURE__ */ o.createElement(F, null, /* @__PURE__ */ o.createElement(
          j,
          {
            type: "tel",
            placeholder: l.fieldsPhonePlaceholder,
            ...i
          }
        )), /* @__PURE__ */ o.createElement(C, { match: "required" }, l.fieldsPhoneValidationErrorsRequired), /* @__PURE__ */ o.createElement(C, { match: "maxLength" }, l.fieldsPhoneValidationErrorsMaxLength))
      }
    ) : null,
    [P.Address1]: b === oe.LOADED ? /* @__PURE__ */ o.createElement(
      q,
      {
        control: u,
        name: p("street"),
        rules: { required: !0, maxLength: 200 },
        render: ({ field: i, fieldState: { error: z } }) => /* @__PURE__ */ o.createElement(_, null, /* @__PURE__ */ o.createElement(A, null, l.fieldsStreetLabel), /* @__PURE__ */ o.createElement(F, null, /* @__PURE__ */ o.createElement(
          sr,
          {
            invalid: !!z,
            defaultValue: f(p("street")),
            onSelectionChange: (v) => {
              g(p("street"), v?.street || "", {
                shouldValidate: !0,
                shouldDirty: !0
              }), g(p("city"), v?.city || "", {
                shouldValidate: !0,
                shouldDirty: !0
              }), g(
                p("province"),
                v?.province ?? "",
                {
                  shouldValidate: !0,
                  shouldDirty: !0
                }
              ), g(p("country"), v?.country || "", {
                shouldValidate: !0,
                shouldDirty: !0
              }), g(
                p("countryCode"),
                v?.countryCode || "",
                {
                  shouldValidate: !0,
                  shouldDirty: !0
                }
              ), g(p("bp"), v?.bp || "", {
                shouldValidate: !0,
                shouldDirty: !0
              });
            },
            onInputChange: (v) => g(p("street"), v, {
              shouldValidate: !0,
              shouldDirty: !0
            }),
            countryRestrictions: s ?? x,
            translations: {
              fieldsStreetPlaceholder: l.fieldsStreetPlaceholder,
              suggestions: l.suggestions
            },
            name: i.name
          }
        )), /* @__PURE__ */ o.createElement(C, { match: "required" }, l.fieldsStreetValidationErrorsRequired), /* @__PURE__ */ o.createElement(C, { match: "maxLength" }, l.fieldsStreetValidationErrorsMaxLength))
      }
    ) : /* @__PURE__ */ o.createElement(
      q,
      {
        control: u,
        name: p("street"),
        rules: { required: !0, maxLength: 200 },
        render: ({ field: i }) => /* @__PURE__ */ o.createElement(_, null, /* @__PURE__ */ o.createElement(A, null, l.fieldsStreetLabel), /* @__PURE__ */ o.createElement(F, null, /* @__PURE__ */ o.createElement(
          j,
          {
            type: "text",
            placeholder: l.fieldsStreetPlaceholder,
            autoComplete: "address-line1",
            ...i
          }
        )), /* @__PURE__ */ o.createElement(C, { match: "required" }, l.fieldsStreetValidationErrorsRequired), /* @__PURE__ */ o.createElement(C, { match: "maxLength" }, l.fieldsStreetValidationErrorsMaxLength))
      }
    ),
    [P.Address2]: /* @__PURE__ */ o.createElement(
      q,
      {
        control: u,
        name: p("street2"),
        rules: { maxLength: 200 },
        render: ({ field: i }) => /* @__PURE__ */ o.createElement(_, null, /* @__PURE__ */ o.createElement(A, null, l.fieldsStreet2Label), /* @__PURE__ */ o.createElement(F, null, /* @__PURE__ */ o.createElement(
          j,
          {
            type: "text",
            placeholder: l.fieldsStreet2Placeholder,
            autoComplete: b === oe.LOADED ? "off" : "address-line2",
            ...i
          }
        )), /* @__PURE__ */ o.createElement(C, { match: "maxLength" }, l.fieldsStreet2ValidationErrorsMaxLength))
      }
    ),
    [P.PostalCode]: /* @__PURE__ */ o.createElement(
      q,
      {
        control: u,
        name: p("bp"),
        rules: {
          required: L.flat().includes(P.PostalCode),
          maxLength: 200
        },
        render: ({ field: i }) => /* @__PURE__ */ o.createElement(_, null, /* @__PURE__ */ o.createElement(A, null, l.fieldsBpLabel), /* @__PURE__ */ o.createElement(F, null, /* @__PURE__ */ o.createElement(
          j,
          {
            type: "text",
            autoComplete: b === oe.LOADED ? "off" : "postal-code",
            placeholder: l.fieldsBpPlaceholder,
            ...i
          }
        )), /* @__PURE__ */ o.createElement(C, { match: "required" }, l.fieldsBpValidationErrorsRequired), /* @__PURE__ */ o.createElement(C, { match: "maxLength" }, l.fieldsBpValidationErrorsMaxLength))
      }
    ),
    [P.City]: /* @__PURE__ */ o.createElement(
      q,
      {
        control: u,
        name: p("city"),
        rules: {
          required: !0,
          maxLength: 200
        },
        render: ({ field: i }) => /* @__PURE__ */ o.createElement(_, null, /* @__PURE__ */ o.createElement(A, null, l.fieldsCityLabel), /* @__PURE__ */ o.createElement(F, null, /* @__PURE__ */ o.createElement(
          j,
          {
            type: "text",
            autoComplete: b === oe.LOADED ? "off" : "address-level2",
            placeholder: l.fieldsCityPlaceholder,
            ...i
          }
        )), /* @__PURE__ */ o.createElement(C, { match: "required" }, l.fieldsCityValidationErrorsRequired), /* @__PURE__ */ o.createElement(C, { match: "maxLength" }, l.fieldsCityValidationErrorsMaxLength))
      }
    ),
    [P.Zone]: (B?.zones?.length ?? 0) > 1 ? /* @__PURE__ */ o.createElement(
      q,
      {
        control: u,
        name: p("province"),
        rules: {
          required: L.flat().includes(P.Zone),
          maxLength: 200
        },
        render: ({ field: i }) => /* @__PURE__ */ o.createElement(_, null, /* @__PURE__ */ o.createElement(A, null, l.fieldsProvinceLabel), /* @__PURE__ */ o.createElement(Ge, { onValueChange: i.onChange, value: i.value }, /* @__PURE__ */ o.createElement(F, null, /* @__PURE__ */ o.createElement(Ze, null, /* @__PURE__ */ o.createElement(
          Ke,
          {
            placeholder: l.fieldsProvinceEmptyField
          }
        ))), /* @__PURE__ */ o.createElement(He, null, B?.zones?.map((z) => /* @__PURE__ */ o.createElement(Be, { value: z.code, key: z.code }, z.name)))), /* @__PURE__ */ o.createElement(C, { match: "required" }, l.fieldsProvinceValidationErrorsRequired), /* @__PURE__ */ o.createElement(C, { match: "maxLength" }, l.fieldsProvinceValidationErrorsRequired))
      }
    ) : /* @__PURE__ */ o.createElement(
      q,
      {
        control: u,
        name: p("province"),
        rules: {
          required: L.flat().includes(P.Zone),
          maxLength: 200
        },
        render: ({ field: i }) => /* @__PURE__ */ o.createElement(_, null, /* @__PURE__ */ o.createElement(A, null, l.fieldsProvinceLabel), /* @__PURE__ */ o.createElement(F, null, /* @__PURE__ */ o.createElement(
          j,
          {
            autoComplete: b === oe.LOADED ? "off" : "address-level1",
            placeholder: l.fieldsProvincePlaceholder,
            ...i
          }
        )), /* @__PURE__ */ o.createElement(C, { match: "required" }, l.fieldsProvinceValidationErrorsRequired), /* @__PURE__ */ o.createElement(C, { match: "maxLength" }, l.fieldsProvinceValidationErrorsRequired))
      }
    ),
    [P.Country]: V ? null : /* @__PURE__ */ o.createElement(
      q,
      {
        control: u,
        name: p("countryCode"),
        rules: {
          required: !0
        },
        render: ({ field: i }) => {
          const z = D.find(
            (v) => v.value === i.value
          );
          return /* @__PURE__ */ o.createElement(_, null, /* @__PURE__ */ o.createElement(A, null, l.fieldsCountryLabel), /* @__PURE__ */ o.createElement(Me, { open: U, onOpenChange: K }, /* @__PURE__ */ o.createElement(De, { asChild: !0 }, /* @__PURE__ */ o.createElement(F, null, /* @__PURE__ */ o.createElement(
            "button",
            {
              type: "button",
              role: "combobox",
              "aria-expanded": U,
              className: 'form-input flex w-full items-center justify-between rounded border-gray-500 text-sm leading-5.5 text-gray-900 transition duration-300 hover:border-gray-700 focus:border-gray-700 focus:ring-1 focus:ring-gray-700 aria-[invalid="true"]:border-red-600 aria-[invalid="true"]:ring-red-600',
              disabled: a
            },
            /* @__PURE__ */ o.createElement("div", { className: "flex items-center truncate" }, i.value ? z?.leftSection : null, /* @__PURE__ */ o.createElement("span", { className: "truncate" }, i.value ? z?.label : l.fieldsCountryPlaceholder)),
            /* @__PURE__ */ o.createElement(
              ce,
              {
                icon: U ? "close" : "arrowDown",
                className: "ml-2 size-4 shrink-0 opacity-50"
              }
            )
          ))), /* @__PURE__ */ o.createElement(
            Te,
            {
              className: "w-full p-0",
              style: {
                width: "var(--radix-popover-trigger-width)"
              }
            },
            /* @__PURE__ */ o.createElement(Ae, { shouldFilter: !1 }, /* @__PURE__ */ o.createElement(
              Fe,
              {
                placeholder: l.fieldsCountryPlaceholderSearch,
                onValueChange: (v) => {
                  se(v), H.current && cancelAnimationFrame(H.current), H.current = requestAnimationFrame(() => {
                    ee.current?.scrollTo({ top: 0 });
                  });
                },
                value: M
              }
            ), /* @__PURE__ */ o.createElement($e, { ref: ee }, /* @__PURE__ */ o.createElement(Oe, null, l.fieldsCountryNoResults), /* @__PURE__ */ o.createElement(je, null, te.map((v) => /* @__PURE__ */ o.createElement(
              Ie,
              {
                key: v.value,
                value: v.value,
                keywords: [v.label],
                onSelect: (O) => {
                  const re = O === i.value ? "" : O;
                  i.onChange(re), g(
                    p("country"),
                    D.find(
                      ($) => $.value === re
                    )?.label ?? ""
                  ), K(!1);
                },
                className: pe("flex items-center justify-between", {
                  "font-semibold text-green-900": i.value === v.value
                })
              },
              /* @__PURE__ */ o.createElement("div", { className: "flex items-center truncate" }, v.leftSection, /* @__PURE__ */ o.createElement("span", { className: "truncate" }, v.label)),
              /* @__PURE__ */ o.createElement(
                ce,
                {
                  icon: "check",
                  className: pe(
                    "ml-2 size-4 shrink-0",
                    i.value === v.value ? "opacity-100" : "opacity-0"
                  )
                }
              )
            )))))
          )), /* @__PURE__ */ o.createElement(C, { match: "required" }, l.fieldsCountryValidationErrorsRequired));
        }
      }
    )
  };
  return k ? null : /* @__PURE__ */ o.createElement("div", { className: "space-y-6" }, L.map(
    (i, z) => i.length > 1 ? /* @__PURE__ */ o.createElement(
      "div",
      {
        className: `grid grid-cols-1 space-y-6 sm:gap-x-6 sm:space-y-0 ${i.length === 2 ? "sm:grid-cols-2" : "sm:grid-cols-3"}`,
        key: z
      },
      i.map(
        (v, O) => /* @__PURE__ */ o.createElement("div", { key: `${z}-${O}` }, W[v])
      )
    ) : W[i[0]] ? /* @__PURE__ */ o.createElement("div", { key: z }, W[i[0]]) : null
  ));
};
export {
  wr as default
};
